export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "最新发布", href: "#feed" },
  { label: "讨论分区", href: "#zones" },
  { label: "热门热议", href: "#hot" },
  { label: "防走丢指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "24h", label: "实时同步" },
  { value: "9.6w+", label: "在站吃瓜" },
  { value: "6 年", label: "不迷路纪录" },
];

export const feedList = [
  {
    tag: "热榜",
    title: "新一季综艺首播口碑两极，弹幕吵翻了，你怎么站队？",
    summary: "首播当天播放量冲高，观众对剪辑节奏与嘉宾配置分歧明显，讨论帖正在迅速攀升，热评区观点已经吵到第三条线。",
    meta: { view: "28.4万", reply: "1863", time: "12 分钟前", hot: true },
  },
  {
    tag: "影视",
    title: "暑期档大片定档，票房预测机构集体上调预期",
    summary: "多部商业片同周上映，档期竞争激烈。业内从宣发物料与预售数据出发，重新评估首周末大盘表现。",
    meta: { view: "19.8万", reply: "940", time: "38 分钟前", hot: false },
  },
  {
    tag: "八卦",
    title: "顶流活动造型引热议，同款穿搭被扒出已售罄",
    summary: "红毯图一出，评论区同步考古同款来源。品牌方临时加货，热搜与商详页流量双涨，一条链路的传播逻辑值得复盘。",
    meta: { view: "35.1万", reply: "2712", time: "1 小时前", hot: true },
  },
  {
    tag: "时事",
    title: "新规落地首日，普通用户最关心的四个点一次讲清",
    summary: "政策细则公布后咨询量井喷。我们按受影响人群整理了速览，把最容易误读的部分单拎出来逐条说明。",
    meta: { view: "41.6万", reply: "3205", time: "2 小时前", hot: true },
  },
  {
    tag: "科技",
    title: "年度开发者大会前瞻：被低估的三个新能力",
    summary: "发布会前流出的功能清单里，有三项看似低调却可能改变使用习惯。圈内已经开始拆解其后续生态影响。",
    meta: { view: "11.2万", reply: "516", time: "3 小时前", hot: false },
  },
  {
    tag: "生活",
    title: "同款网红夜市美食复刻实测，踩坑与成功点都写明白了",
    summary: "照着热门视频复刻三样小吃，从火候到酱料比例逐项记录，结论可能和你想象的不太一样。",
    meta: { view: "8.9万", reply: "402", time: "4 小时前", hot: false },
  },
  {
    tag: "娱评",
    title: "为什么这段采访切片能在评论区被反复解读两天",
    summary: "一段十几秒的回答，为何发酵出多种解读方向？我们从传播链条与语境还原两个角度聊了聊这件事。",
    meta: { view: "15.7万", reply: "1208", time: "5 小时前", hot: false },
  },
  {
    tag: "热榜",
    title: "本周社区热议 TOP10，看看有没有你漏掉的瓜",
    summary: "过去七天讨论热度最高的十个话题合集，覆盖娱乐、时事、科技与生活方式，补课指南一键到位。",
    meta: { view: "52.3万", reply: "4890", time: "6 小时前", hot: true },
  },
];

export const guideSteps = [
  {
    step: "01",
    icon: "ri-bookmark-3-line",
    title: "收藏本页",
    desc: "把当前页面加入浏览器书签，网址一旦变更会在首页顶部同步显示新入口，回到收藏即可找到。",
  },
  {
    step: "02",
    icon: "ri-notification-3-line",
    title: "订阅更新提醒",
    desc: "开启更新提醒后，出现防屏蔽 / 更换新网址时会第一时间推送，不依赖记忆也不怕漏掉。",
  },
  {
    step: "03",
    icon: "ri-apps-2-line",
    title: "下载官方 App",
    desc: "App 内集成多入口自动切换与离线公告，适合经常断连的环境，是体验最稳的防走丢方式。",
  },
  {
    step: "04",
    icon: "ri-shield-check-line",
    title: "关注备用地址",
    desc: "除了主入口，我们还长期维护一组备用域名，主站异常时可平滑跳转，做到真正的永久入口。",
  },
];

export const zones = [
  { icon: "ri-chat-smile-3-line", name: "八卦闲聊", topics: "3.2w 主题", members: "12.4w 人", desc: "娱乐八卦与圈内消息的开放讨论区，气氛最热闹。" },
  { icon: "ri-flashlight-line", name: "时事速递", topics: "1.8w 主题", members: "8.9w 人", desc: "热点事件一手讨论，强调信息与语境还原。" },
  { icon: "ri-clapperboard-line", name: "影视剧综", topics: "2.6w 主题", members: "9.7w 人", desc: "新剧新综的追更、安利与避雷现场。" },
  { icon: "ri-cpu-line", name: "科技数码", topics: "1.4w 主题", members: "6.1w 人", desc: "新机发布、行业动态与数码体验分享。" },
  { icon: "ri-cake-3-line", name: "生活现场", topics: "2.2w 主题", members: "7.3w 人", desc: "探店复刻、省钱攻略与真实生活记录。" },
  { icon: "ri-music-2-line", name: "音乐演出", topics: "0.9w 主题", members: "4.2w 人", desc: "演唱会、综艺舞台与音乐现场的话题区。" },
  { icon: "ri-shield-star-line", name: "防走丢互助", topics: "0.5w 主题", members: "3.8w 人", desc: "网址异常、屏蔽反馈与新入口求助都在这里。" },
  { icon: "ri-user-follow-line", name: "新人报到", topics: "0.7w 主题", members: "5.5w 人", desc: "第一次来的朋友在此报到，快速了解社区规则。" },
];

export const hotPosts = [
  {
    title: "一张图看懂：这两件事其实是一码事",
    summary: "把表面热闹的信息用时间线串起来，你会发现很多争论其实是同一个问题的两个切面。",
    likes: "2.1w",
    views: "31.6w",
    image: "https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20illustration%20of%20friends%20discussing%20while%20watching%20a%20phone%20screen%20showing%20trending%20chips%2C%20speech%20bubbles%20floating%2C%20fresh%20tangerine%20and%20soft%20green%20palette%2C%20minimalist%20flat%20vector%2C%20community%20atmosphere%2C%20clean%20and%20no%20text&width=760&height=520&seq=hot-feed-01&orientation=landscape",
  },
  {
    title: "争议热搜前后三天，讨论走向复盘",
    summary: "从爆发、反转到降温，拆解一条热搜为何能反复刷屏，背后是情绪、信息差还是运营节奏。",
    likes: "1.7w",
    views: "24.9w",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20trending%20topic%20timeline%20board%20with%20pushpins%20and%20connected%20notes%2C%20warm%20cream%20background%2C%20tangerine%20and%20green%20accents%2C%20minimalist%20flat%20vector%20storytelling%2C%20no%20text&width=760&height=520&seq=hot-feed-02&orientation=landscape",
  },
  {
    title: "同一部剧，观众与媒体视角差在哪",
    summary: "为什么口碑两极的剧，专业评分和观众弹幕给出的结论常常相反？我们把双方标准摊开对比。",
    likes: "1.4w",
    views: "19.2w",
    image: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20two%20audiences%20watching%20the%20same%20screen%20from%20different%20angles%2C%20cream%20background%2C%20cinema%20seats%2C%20tangerine%20and%20soft%20green%20palette%2C%20minimalist%20flat%20vector%2C%20no%20text&width=760&height=520&seq=hot-feed-03&orientation=landscape",
  },
];

export const updates = [
  { date: "09/07", type: "同步", title: "新增一套备用入口并完成线路测速", text: "为应对高峰时段波动，主备线路已自动切换测试，当前访问更稳。" },
  { date: "09/05", type: "优化", title: "防走丢提醒支持订阅偏好设置", text: "用户可自行选择接收新网址、屏蔽预警或周报，减少打扰。" },
  { date: "09/02", type: "公告", title: "《社区讨论规范》更新说明", text: "细化了热点话题的标题规范与搬运边界，讨论秩序更清晰。" },
  { date: "08/29", type: "功能", title: "App 新增深色模式与离线公告缓存", text: "弱网环境也能读取最新入口公告，进一步降低走丢概率。" },
];

export const faqs = [
  { q: "页面打不开，怎么找到最新网址？", a: "先回到本页书签，顶部会实时展示当前有效入口；若仍异常，可前往「防走丢互助」分区查看其他用户反馈的可用地址。" },
  { q: "换新网址后，旧收藏还管用吗？", a: "旧入口失效时会被自动指向公告，首页同步更新跳转提示。长期使用建议订阅更新提醒或收藏永久入口页面。" },
  { q: "如何判断一个地址是官方而非假冒？", a: "认准页脚的永久入口标识与域名规则，遇到异常先到互助区核对，不要轻易在来路不明的页面输入账号。" },
  { q: "App 和网页版有什么区别？", a: "App 内置多线路自动切换、推送提醒与离线公告，网页版则更适合快速临时访问，两者数据互通。" },
  { q: "屏蔽导致访问困难，有没有更稳的方案？", a: "优先使用 App 的自动切换，其次关注备用域名公告。若所在网络波动较大，可到互助区获取镜像入口。" },
];

export const footerLinks = {
  about: ["关于吃瓜地址", "社区讨论规范", "版权与免责", "联系我们"],
  guide: ["永久入口", "防走丢指南", "App 下载", "更新记录"],
  support: ["帮助中心", "反馈与建议", "隐私声明", "友情链接"],
};